import { HERO_BG, FLORAL_ACCENT, HONOREE } from "@/lib/eventConfig";

export default function Hero() {
  return (
    <section
      className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden paper-grain"
      data-testid="hero-section"
    >
      {/* Background watercolor */}
      <div className="absolute inset-0 -z-10">
        <img
          src={HERO_BG}
          alt=""
          aria-hidden="true"
          className="w-full h-full object-cover opacity-70"
        />
        <div className="absolute inset-0 bg-[#FAF9F6]/40" />
      </div>

      {/* Floral accents */}
      <img
        src={FLORAL_ACCENT}
        alt=""
        aria-hidden="true"
        className="absolute -top-8 -left-6 w-40 sm:w-56 md:w-72 opacity-60 floaty pointer-events-none"
      />
      <img
        src={FLORAL_ACCENT}
        alt=""
        aria-hidden="true"
        className="absolute -bottom-12 -right-8 w-44 sm:w-64 md:w-80 opacity-50 floaty pointer-events-none rotate-180"
        style={{ animationDelay: "2s" }}
      />

      <div className="relative z-10 text-center px-6 max-w-4xl">
        <p className="label-eyebrow" data-testid="hero-eyebrow">
          A celebration of light · 10 — 12 September, 2026
        </p>

        <h1
          className="font-serif-display text-[#4A5346] text-6xl sm:text-7xl md:text-8xl lg:text-[9rem] mt-8 leading-[0.95]"
          data-testid="hero-name"
        >
          {HONOREE}
        </h1>

        <div className="ornamental-rule mt-10">
          <span className="font-serif-display italic text-lg sm:text-xl text-[#8FA092]">
            is being baptised
          </span>
        </div>

        <p className="mt-10 max-w-xl mx-auto text-[#757E70] leading-relaxed text-base sm:text-lg">
          We warmly invite you to share in three days of prayer,
          ceremony, and feasting as we welcome our beloved
          into a life of grace and light.
        </p>

        <div className="mt-14 flex flex-col sm:flex-row items-center justify-center gap-5">
          <a href="#rsvp" className="btn-soft" data-testid="hero-rsvp-cta">
            RSVP
          </a>
          <a
            href="#itinerary"
            className="text-sm tracking-[0.22em] uppercase text-[#4A5346] hover:text-[#8FA092] transition-colors"
            data-testid="hero-itinerary-cta"
          >
            View itinerary →
          </a>
        </div>
      </div>

      {/* Scroll hint */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-3 text-[#8FA092]">
        <div className="w-px h-12 bg-[#8FA092]/40" />
        <span className="text-[10px] tracking-[0.3em] uppercase">Scroll</span>
      </div>
    </section>
  );
}
